var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 925,
    height: 982,
    viewBox: "0 0 925 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M895.002 894.948C959.846 894.948 1012.41 842.38 1012.41 777.536C1012.41 712.691 959.846 660.124 895.002 660.124C830.157 660.124 777.59 712.691 777.59 777.536C777.59 842.38 830.157 894.948 895.002 894.948Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.996 425.612C183.84 425.612 236.407 373.046 236.407 308.201C236.407 243.356 183.84 190.789 118.996 190.789C54.151 190.789 1.58398 243.356 1.58398 308.201C1.58398 373.046 54.151 425.612 118.996 425.612Z",
    fill: "#00A14B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M896.587 428.28C961.432 428.28 1014 375.713 1014 310.869C1014 246.024 961.432 193.457 896.587 193.457C831.743 193.457 779.176 246.024 779.176 310.869C779.176 375.713 831.743 428.28 896.587 428.28Z",
    fill: "#7F3F98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.412 892.286C182.256 892.286 234.823 839.719 234.823 774.875C234.823 710.03 182.256 657.463 117.412 657.463C52.567 657.463 0 710.03 0 774.875C0 839.719 52.567 892.286 117.412 892.286Z",
    fill: "#FFDE17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M506.968 1113.74C571.813 1113.74 624.38 1061.17 624.38 996.326C624.38 931.481 571.813 878.914 506.968 878.914C442.124 878.914 389.557 931.481 389.557 996.326C389.557 1061.17 442.124 1113.74 506.968 1113.74Z",
    fill: "#F7941D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M506.968 206.823C571.813 206.823 624.38 154.256 624.38 89.4117C624.38 24.567 571.813 -28 506.968 -28C442.124 -28 389.557 24.567 389.557 89.4117C389.557 154.256 442.124 206.823 506.968 206.823Z",
    fill: "#1C75BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M506.207 812.196C574.766 812.196 634.201 844.194 663.601 890.956C647.443 822.334 582.876 771.01 506.207 771.01C429.538 771.01 364.908 822.334 348.75 890.766C378.15 844.194 437.585 812.196 506.207 812.196Z",
    fill: "#F7941D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M506.207 284.002C437.585 284.002 378.15 252.004 348.75 205.242C364.908 273.864 429.221 325.188 506.207 325.188C583.193 325.188 647.443 273.864 663.601 205.242C634.201 252.004 574.766 284.002 506.207 284.002Z",
    fill: "#1C75BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M731.461 685.973C767.261 627.425 825.619 593.463 880.681 592.956C813.707 570.905 736.34 599.292 696.168 664.619C655.996 729.947 666.197 811.938 716.381 861.488C691.923 811.875 695.661 744.457 731.461 685.973Z",
    fill: "#ED1C24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M280.889 410.218C245.089 468.766 186.795 502.728 131.605 503.425C198.58 525.475 275.946 497.089 316.055 431.762C356.164 366.434 346.026 284.442 295.906 234.893C320.427 284.316 316.752 351.734 280.889 410.218Z",
    fill: "#00A14B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M731.464 410.218C767.264 468.766 825.621 502.728 880.81 503.425C813.836 525.475 736.469 497.089 696.297 431.762C656.125 366.434 666.326 284.442 716.51 234.893C691.925 284.316 695.663 351.734 731.464 410.218Z",
    fill: "#7F3F98"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.889 685.973C245.089 627.425 186.795 593.463 131.605 592.956C198.58 570.905 275.946 599.292 316.055 664.619C356.164 729.947 346.026 811.938 295.906 861.488C320.427 811.875 316.752 744.457 280.889 685.973Z",
    fill: "#FFDE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogo);
export default __webpack_public_path__ + "static/media/backgroundLogo.39590d5a784a4bbd1a869077c8f188e7.svg";
export { ForwardRef as ReactComponent };